export const UPDATE_OPERATOR_NODE_REQUEST = "UPDATE_OPERATOR_NODE_REQUEST";
export const UPDATE_OPERATOR_NODE_SUCCESS = "UPDATE_OPERATOR_NODE_SUCCESS";
export const UPDATE_OPERATOR_NODE_FAILURE = "UPDATE_OPERATOR_NODE_FAILURE";
